/**
 * 캘린더 3열 셸(calendar shell) — 레이아웃 참조 플래그.
 * 참조 SSOT: `docs/all-frame.html` 04 캘린더 / 옵션 3b (L1109~1216).
 *
 * ⑦ 캘린더 좌측 사이드바(미니 캘린더 + 다가올 일정 + 캘린더 목록) & 우측 선택일 레일 노출 플래그.
 *   **기본 ON**.
 *   - ON  : `.calendar-page--shell` 3열 골격. 캘린더 목록이 사이드바에 상시 노출되고,
 *           헤더 드롭다운은 유형 범례만 담당한다.
 *   - OFF : 롤백 경로 — 기존 `.calendar-page--full` 전체폭 + 헤더 '캘린더·필터' 드롭다운 안에
 *           캘린더 목록/범례. `VITE_CAL_SHELL='0'` 으로 끈다.
 *
 * ⚠ 플래그와 무관하게 MonthView/TimeGridView/Event*Modal/DayPopover 는 동일하게 mount 된다.
 *   셸은 기존 렌더 경로를 감싸기만 하며(additive), 이벤트 조회·생성·수정 경로를 바꾸지 않는다.
 *   (docs/design 의 `SHELL_STATUSBAR_ENABLED` 와 동형 — 롤백 1스위치 정책)
 */
export const CAL_SHELL_ENABLED = import.meta.env.VITE_CAL_SHELL !== '0';

/** 로컬 날짜 키(YYYY-MM-DD). UTC 변환 없이 로컬 기준 — toISOString 은 KST 에서 하루 밀린다. */
export function calDateKey(d: Date): string {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

/** 같은 날(로컬) 인지. */
export function isSameCalDay(a: Date, b: Date): boolean {
  return calDateKey(a) === calDateKey(b);
}

/**
 * 특정 날짜에 걸친 일정(멀티데이 포함) — `start < dayEnd && end > dayStart`.
 * CalendarPage.eventsOnDate 와 동일 규칙(중복 구현이 아니라 셸 컴포넌트가 공유하는 순수 함수).
 */
export function eventsOnDay<T extends { startAt: string; endAt: string }>(events: T[], date: Date): T[] {
  const dayStart = new Date(date); dayStart.setHours(0, 0, 0, 0);
  const dayEnd = new Date(dayStart); dayEnd.setDate(dayStart.getDate() + 1);
  return events.filter((e) => {
    const s = new Date(e.startAt); const en = new Date(e.endAt);
    return s < dayEnd && en > dayStart;
  });
}
